import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colours = tokens.colors;
var mini = designTokenFonts.mini;
export var container = {
  name: "13o7eu2",
  styles: "display:block;"
};
export var cardContainer = {
  name: "qi6b8j",
  styles: "display:flex;flex-direction:row;gap:8px;margin:11px 0 10px 0;overflow:auto hidden;-ms-overflow-style:none;scrollbar-width:none;::-webkit-scrollbar{display:none;}"
};
export var message = /*#__PURE__*/css(mini, ";color:", colours.interactive.base.default, ";");